import { render, staticRenderFns } from "./ListAdd.vue?vue&type=template&id=270226ae&"
import script from "./ListAdd.vue?vue&type=script&lang=js&"
export * from "./ListAdd.vue?vue&type=script&lang=js&"
import style0 from "./ListAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports